import * as lazySizes from 'lazysizes'
import 'lazysizes/plugins/native-loading/ls.native-loading'
import 'lazysizes/plugins/object-fit/ls.object-fit'
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import '@babel/plugin-syntax-dynamic-import'
import * as conditioner from 'conditioner-core/conditioner-core.min'

import '../styles/app.scss'
import consola, { LogLevel, LogLevels } from 'consola'
import Util from './utils/Util'
import TrackingHelper from './utils/TrackingHelper'
import BatchTrackingHelper from './utils/BatchTrackingHelper'
import PooolNewsletterHelper from './utils/PooolNewsletterHelper'

// - define consola
consola.level = Util.isDebugLogs() ? LogLevels.trace : LogLevels.warn

document.documentElement.className = 'js'

conditioner.addPlugin({
  monitor: {
    name: 'visible',
    create: (context: boolean, element: HTMLElement) => ({
      matches: false,
      addListener (change: Function) {
        new IntersectionObserver((entries: any[]) => {
          this.matches = entries?.pop()?.isIntersecting === context
          change()
        }).observe(element)
      }
    })
  },

  moduleSetName: (name: string) => `./modules/${name}.ts`,
  moduleGetConstructor: (module: any) => module.default,
  moduleImport: async (name: string) => await import(/* webpackMode: "lazy" */`${name}`)
})

conditioner.hydrate(document.documentElement)

// Handle Post hit
const hitEl: HTMLElement = document.querySelector('[data-hit]')
if (hitEl) {
  const hitUrl = hitEl.getAttribute('data-hit')
  if (hitUrl) {
    fetch(hitUrl, {
      method: 'POST'
    })
  }
}

/**
 * LazySizes configuration
 * https://github.com/aFarkas/lazysizes/#js-api---options
 */
lazySizes.cfg.nativeLoading = {
  setLoadingAttribute: false
}

TrackingHelper.init()
BatchTrackingHelper.init()
PooolNewsletterHelper.init()
